import React, { createContext, useReducer } from 'react'

export const SHOW_FETCH_MEMO_POPUP = 'SHOW_FETCH_MEMO_POPUP'
export const SET_DTC_MEMO_LIST = 'SET_DTC_MEMO_LIST'
export const SELECT_DTC_MEMO = 'SELECT_DTC_MEMO'
export const SET_UPDATED_DTC_MEMO = 'SET_UPDATED_DTC_MEMO'
export const SHOW_DTC_MEMO_POPUP = 'SHOW_DTC_MEMO_POPUP'
export const SET_MEMOS_DATE = 'SET_MEMOS_DATE'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_DTC_MEMO_LIST: {
      return { ...data, memo_list: payload.data }
    }
    case SET_UPDATED_DTC_MEMO: {
      let memo_list = [...data.memo_list]
      memo_list[payload.data.index] = payload.data
      return { ...data, memo_list: memo_list }
    }
    case SELECT_DTC_MEMO: {
      return {
        ...data,
        selected_memo: payload.data.selected_memo,
        show_memo_popup: payload.data.show_memo_popup,
      }
    }
    case SHOW_FETCH_MEMO_POPUP: {
      return { ...data, show_fetch_memo_popup: payload.data }
    }
    case SET_MEMOS_DATE: {
      return { ...data, memos_date: payload.data }
    }
    default: {
      return data
    }
  }
}

const initialState = {
  memo_list: [],
  selected_memo: [],
  show_fetch_memo_popup: false,
  show_memo_popup: false,
  memos_date: null,
}

const MemoStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <MemoContext.Provider value={[state, dispatch]}>
      {children}
    </MemoContext.Provider>
  )
}

export const MemoContext = createContext(initialState)
export default MemoStore
